module.exports = __webpack_public_path__ + "img/consistent_histories_nav.0131a6a4.png";